module.exports = __webpack_public_path__ + "static/media/errorpage.ae23fe61.png";